// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2t6Ty","modalFooterButton":"ModalNotes_modalFooterButton__24EVI"};